const Pagination = ({ data, pagination, setPagination }) => {
  const DOTS = "...";

  const range = (start, end) => {
    let length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
  };

  const paginationRange = () => {
    const totalPageNumbers = 5;
    const totalPageCount = data?.last_page;

    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }

    const leftSiblingIndex = Math.max(data?.current_page - 1, 1);
    const rightSiblingIndex = Math.min(data?.current_page + 1, totalPageCount);

    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;

    if (!shouldShowLeftDots && shouldShowRightDots) {
      let leftItemCount = 3 + 2 * 1;
      let leftRange = range(1, leftItemCount);

      return [...leftRange, DOTS, totalPageCount];
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      let rightItemCount = 3 + 2 * 1;
      let rightRange = range(
        totalPageCount - rightItemCount + 1,
        totalPageCount
      );
      return [firstPageIndex, DOTS, ...rightRange];
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      let middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
    }
  };

  return (
    <nav
      className="flex items-center flex-column flex-wrap md:flex-row justify-between pt-4"
      aria-label="Table navigation"
    >
      <span className="text-sm font-normalmb-4 md:mb-0 block w-full md:inline md:w-auto">
        Showing
        <span className="font-semibold text-gray-900 mx-1">
          {data?.from}-{data?.to}
        </span>
        of
        <span className="font-semibold text-gray-900 mx-1">{data?.total}</span>
      </span>
      <ul className="inline-flex -space-x-px rtl:space-x-reverse text-sm h-8">
        <li>
          <button
            disabled={data?.current_page <= 1}
            onClick={() => setPagination(pagination - 1)}
            className="flex items-center justify-center px-3 h-8 ms-0 leading-tightbg-white border border-black rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
          >
            Prev
          </button>
        </li>

        {paginationRange()?.map((item, index) => (
          <li key={index}>
            <button
              onClick={() => setPagination(item)}
              className={`flex items-center justify-center px-3 h-8 border border-black hover:bg-gray-100 ${
                item === data?.current_page
                  ? "bg-gray-200 active"
                  : "leading-tightbg-white hover:text-gray-700"
              }`}
            >
              {item}
            </button>
          </li>
        ))}

        <li>
          <button
            disabled={data?.current_page === data?.last_page}
            onClick={() => setPagination(pagination + 1)}
            className="flex items-center justify-center px-3 h-8 leading-tightbg-white border border-black rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
